import { useMutation } from '@tanstack/react-query';

import { type PluginName } from '~/hooks/api/usePluginAuthState';

export type UseAuthStateMutationParams = {
  apiEndpoint: string;
  pluginName: PluginName;
};

export const useAuthStateMutation = ({ apiEndpoint, pluginName }: UseAuthStateMutationParams) => {
  return useMutation({
    mutationFn: async ({ code, id, state }: { code: string; id: string; state: string }) => {
      if (!id) {
        throw new Error('No id found');
      }

      const response = await fetch(`${apiEndpoint}/pluginAuth/state`, {
        body: JSON.stringify({ code, id, pluginName, state }),
        headers: {
          'Content-Type': 'application/json',
        },
        method: 'POST',
      });

      if (!response.ok) {
        throw new Error(`Failed to save auth state: ${response.status} ${response.statusText}`);
      }

      return response;
    },
  });
};
